export function errorToJSON(err): {
  name: string;
  message: string;
  stack: string;
  cause?: any;
} {
  return {
    name: err.name,
    message: err.message,
    stack: err.stack,
    ...(err.cause && { cause: err.cause }),
  };
}
